"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isColor;
function isColor(str) {
  return typeof str === 'string' && (str.startsWith('rgb') || str.startsWith('#'));
}